import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input"> & { variant?: "default" | "filled" | "ghost" }>(
  ({ className, type, variant = "default", ...props }, ref) => {
    const variants = {
      default: "border-input bg-background text-foreground placeholder:text-muted-foreground focus-visible:ring-ring focus-visible:border-ring",
      filled: "border-border bg-secondary text-foreground placeholder:text-muted-foreground focus-visible:ring-ring focus-visible:bg-background",
      ghost: "border-transparent bg-transparent text-foreground placeholder:text-muted-foreground focus-visible:ring-ring focus-visible:border-transparent"
    }

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-xl border px-4 py-2 text-sm font-medium transition-all duration-200",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:shadow-inner-glow",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:cursor-not-allowed",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium",
          variants[variant],
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

const InputGroup = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("relative", className)}
    {...props}
  />
))
InputGroup.displayName = "InputGroup"

const InputPrefix = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={cn("absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground", className)}>
    {children}
  </div>
)

const InputSuffix = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={cn("absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground", className)}>
    {children}
  </div>
)

export { Input, InputGroup, InputPrefix, InputSuffix }
